import { locationIdFormat } from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const RedoFulfillmentToteSchema_ = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  name: z.string(),
  barcode: z.string(),
  barcodeUrl: z.string().nullish(),
  pickSessionId: z.string().nullish(),
  toteGroupId: zExt.objectId().nullish(),
  locationId: locationIdFormat.schema.nullish(),
});
export const RedoFulfillmentToteSchema: z.ZodType<RedoFulfillmentTote> =
  RedoFulfillmentToteSchema_;

export interface RedoFulfillmentTote
  extends z.infer<typeof RedoFulfillmentToteSchema_> {}
